export default __webpack_public_path__ + "static/media/r4_claymore_favonius_greatsword.2adef8ba.png";